(() => {
  const cleanDescriptionTables = (root) => {
    if (!root) return;

    root.querySelectorAll('[class*="Divider"], hr').forEach((el) => el.remove());
    root.querySelectorAll('[class*="TableFrame"]').forEach((el) => {
      if (!el.textContent.trim()) el.remove();
    });

    root.querySelectorAll("td, th").forEach((cell) => {
      const text = (cell.textContent || "").replace(/\u00a0/g, " ").trim();
      if (text === ":" || text === "：") {
        cell.remove();
        return;
      }

      const walker = document.createTreeWalker(cell, NodeFilter.SHOW_TEXT);
      let node = walker.nextNode();
      while (node) {
        if (!node.textContent.replace(/\u00a0/g, " ").trim()) {
          node = walker.nextNode();
          continue;
        }
        node.textContent = node.textContent.replace(/^\s*[:：]\s*/, "");
        break;
      }
    });
  };

  const bindStory = (section) => {
    if (section.dataset.storyBound === "true") return;
    section.dataset.storyBound = "true";

    const inner = section.querySelector(".m-product-story__inner");
    const media = section.querySelector(".m-product-story__media");
    const copy = section.querySelector("[data-story-copy]");
    const scroll = section.querySelector("[data-story-scroll]");
    const content = section.querySelector(".m-product-story__content");

    cleanDescriptionTables(content);

    if (!inner || !copy || !scroll) return;

    const image = media ? media.querySelector("img") : null;

    const sync = () => {
      copy.style.height = "";
      scroll.style.maxHeight = "";
      scroll.classList.remove("has-overflow");

      if (!media || inner.classList.contains("m-product-story__inner--text-only") || window.innerWidth < 768) {
        const mobileCap = Math.round(Math.min(window.innerHeight * 0.55, 420));
        scroll.style.maxHeight = `${mobileCap}px`;
        if (scroll.scrollHeight > scroll.clientHeight + 4) {
          scroll.classList.add("has-overflow");
        }
        return;
      }

      const mediaHeight = media.getBoundingClientRect().height;
      if (!mediaHeight) return;

      copy.style.height = `${Math.round(mediaHeight)}px`;

      const heading = copy.querySelector(".m-product-story__heading");
      const headingHeight = heading ? heading.getBoundingClientRect().height + 16 : 0;
      const available = Math.max(80, Math.round(mediaHeight - headingHeight));
      scroll.style.maxHeight = `${available}px`;

      if (scroll.scrollHeight > scroll.clientHeight + 4) {
        scroll.classList.add("has-overflow");
      }
    };

    const scheduleSync = () => requestAnimationFrame(sync);

    if (image) {
      if (image.complete) scheduleSync();
      else image.addEventListener("load", scheduleSync, { once: true });
    } else {
      scheduleSync();
    }

    window.addEventListener("resize", scheduleSync);
    if ("ResizeObserver" in window && media) {
      new ResizeObserver(scheduleSync).observe(media);
    }
  };

  document.querySelectorAll(".m-product-story").forEach(bindStory);
  document.querySelectorAll(".m-product-description.rte, .template-product .rte").forEach(cleanDescriptionTables);
})();
